import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isContactsAddress(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.CONTACTS_ADDRESS && typeof label === 'string' && typeof value === 'string';
}
function _formatContactsAddress(_ref) {
  let {
    field,
    value
  } = _ref;
  if (!value) {
    return;
  }
  return {
    label: field.view.label,
    value
  };
}
export function formatContactsAddress(submission) {
  if (isContactsAddress(submission)) {
    return _formatContactsAddress(submission);
  }
  return undefined;
}
//# sourceMappingURL=contacts-address-preview.js.map